<div class="col" *ngIf="data!=null">
    <div class="table-responsive">
        <table class="table table-striped table-bordered">
            <thead class="table-light">
                <tr>
                <th *ngFor="let col of columns"
                    [class.text-end]="col.align === 'end'">
                    {{ col.label }}
                </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let row of data">
                <td *ngFor="let col of columns"
                    [class.text-end]="col.align === 'end'">

                    <!-- porcentaje -->
                    <ng-container *ngIf="col.format === 'percent'; else notPercent">
                    {{ row[col.key] | number:'1.2-4' }} %
                    </ng-container>

                    <!-- resto -->
                    <ng-template #notPercent>
                    <ng-container *ngIf="col.format === 'money'; else normal">
                        {{ row[col.key] | number:'1.2-2' }}
                    </ng-container>
                    </ng-template>

                    <ng-template #normal>
                    {{ row[col.key] }}
                    </ng-template>

                </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>